module.exports = __webpack_public_path__ + "img/reset_appliance_step_3.5edcbc45.gif";